export default __webpack_public_path__ + "static/media/gallery-wip-blade plug pin_02.5e0da810.jpg";